import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission.js'
import installDirective from '@/directives/index'
// import '@/utils/load'

import '@/icons/index.js'
import SvgIcon from '@/components/SvgIcon/index.vue'
import VuePdf from 'vue3-pdfjs'

import 'windi.css'
import '@/assets/style/reset.scss'

// require('./mock')

const app = createApp(App)

installDirective(app)

app.use(store)
app.use(router)
app.component('svg-icon', SvgIcon)
app.use(VuePdf)
app.mount('#app')
